import { Validators } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

export const RELATIVE_URL = 'global-config';

export const CES_CONFIG_FIELDS: IFieldConfig[] = [
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    name: 'interest',
    label: 'Taxa de Juros (%)',
    placeholder: 'Informe a taxa de juros em %',
    validation: [
      Validators.required,
      Validators.min(0),
      Validators.max(100)
    ]
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    name: 'interestDescription',
    label: 'Descrição da Taxa de Juros',
    placeholder: 'Descreva a finalidade da taxa de juros',
    validation: []
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    name: 'fine',
    label: 'Valor da Multa (%)',
    placeholder: 'Informe o valor da multa em %',
    validation: [
      Validators.required,
      Validators.min(0),
      Validators.max(100)
    ]
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    name: 'fineDescription',
    label: 'Descrição da Multa',
    placeholder: 'Descreva a finalidade da multa',
    validation: []
  },
];
